import axios from 'axios';
import store from '../redux/store/store';
import { string } from 'prop-types';
const API_OUTWARD_URL = import.meta.env.VITE_OUTWARD_URL;

/** API: dizi, CategoryMemory, BaseResult sarmalayıcı veya PascalCase alanlar. */
const extractOutwardCategoryList = (input) => {
    let cur = input;
    for (let depth = 0; depth < 6 && cur != null; depth++) {
        if (Array.isArray(cur)) return cur;
        if (typeof cur !== "object") return [];
        if (Array.isArray(cur.category)) return cur.category;
        if (Array.isArray(cur.Category)) return cur.Category;
        if (cur.data !== undefined) {
            cur = cur.data;
            continue;
        }
        break;
    }
    return [];
};

const outWardService = {
    fetchCategory: async (
        marketPlaceName,
        requestBody,
        token,
        platformType = "marketplace"
    ) => {
        try {
            const authToken =
                token ?? store.getState()?.auth?.user?.accessToken?.token;
            const segment =
                platformType === "ecommerce" ? "Ecommerce" : "MarketPlace";
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/${segment}/${marketPlaceName}/Category`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return extractOutwardCategoryList(response?.data);
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },


    fetchCategoryAttribute: async (marketPlaceName, requestBody, token) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const mpLen = requestBody?.marketPlaceSetting?.length ?? 0;
            const type = mpLen > 0 ? "MarketPlace" : "Ecommerce";
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/${type}/${marketPlaceName}/CategoryAttribute`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response?.data?.categoryAttributes;
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },


    fetchBrand: async (marketPlaceName, requestBody, token) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/MarketPlace/${marketPlaceName}/Brand`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },




    sendProduct: async (marketPlaceName, requestBody, token, selectedPlatformType) => {
        try {
            const userToken =
                token ?? store.getState()?.auth?.user?.accessToken?.token;
            var type = selectedPlatformType == "ecommerce" ? "Ecommerce" : "MarketPlace";
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/${type}/${marketPlaceName}/Product`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },


    paymentStatus: async (gateway, paymentId) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.get(
                `${API_OUTWARD_URL}/OutWard/Payment/${gateway}/Pay?paymentId=${paymentId}`, // Parametreleri URL'ye ekledik
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch payment status. Please check the logs.");
        }
    },

    paymentTokenStatus: async (gateway, token) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.get(
                `${API_OUTWARD_URL}/OutWard/Payment/${gateway}/Pay?token=${token}`,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch payment status. Please check the logs.");
        }
    },

    payment: async (request) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/Payment/Iyzico/Pay`,
                request,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },




    fetchPlaceProduct: async (placeName, requestBody) => {
        try {

            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/MarketPlace/${placeName}/FetchProduct`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },






    stockAndPrice: async (marketPlaceName, requestBody, selectedPlatformType) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            var type = selectedPlatformType == "ecommerce" ? "Ecommerce" : "MarketPlace";
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/${type}/${marketPlaceName}/StockAndPrice`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },



    transferInvoice: async (data) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.post(`/OutWard/Invoice/Turkcell`, data, {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            console.error('Invoice API Error:', {
                message: error.message,
                response: error.response?.data,
                data: error.response?.data?.data
            });
            throw error;
        }
    },


    transferInvoice: async (invoice) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/Invoice/Turkcell`,
                invoice,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Add Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
                return error?.response?.data;
            }
        }
    },

    sendInvoiceMarketplace: async (request, marketPlaceName) => {
        console.log(request)
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(`${API_OUTWARD_URL}/Outward/MarketPlace/${marketPlaceName}/InvoiceLink`, request, {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            console.error('Invoice API Error:', {
                message: error.message,
                response: error.response?.data,
                data: error.response?.data?.data
            });
            throw error;
        }
    },


     fetchLocation: async (marketPlaceName, requestBody) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/Ecommerce/${marketPlaceName}/Location`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },

    fetchSalesChannel: async (marketPlaceName, requestBody) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/Ecommerce/${marketPlaceName}/SalesChannel`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch sales channel details. Please check the logs.");
        }
    },

      sendProductBackground: async (marketPlaceName, requestBody, token, selectedPlatformType) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            var type = selectedPlatformType == "ecommerce" ? "Ecommerce" : "MarketPlace";
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/${type}/Task/${marketPlaceName}/ProductTask`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },

     getCargoProvider: async (marketPlaceName, requestBody) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_OUTWARD_URL}/OutWard/MarketPlace/${marketPlaceName}/CargoProvider`,
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error("Backend Error:", {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else if (error.request) {
                console.error("Request Error: No response received", error.request);
            } else {
                console.error("Axios Error: Configuration issue", error.message);
            }
            throw new Error("Failed to fetch brand details. Please check the logs.");
        }
    },

}
export default outWardService;
